import React, { useMemo } from "react";
import classNames from "classnames";
import { Player } from "@lottiefiles/react-lottie-player";
import { useMobileAppParams } from "App/routes/Main/useMobileAppParams";
import { FROM_MOBILE_APP_FLAG, routePaths } from "App/modules/urls";
import "./styles.scss";

const LoadingScreen = ({ fixed }: { fixed?: boolean }) => {
  const { isAuthorizedMobileComponent } = useMobileAppParams();

  const isTrackStoriesFromMobile = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const fromMobileApp = searchParams.has(FROM_MOBILE_APP_FLAG);
    return (
      window.location.pathname === routePaths.trackstories && fromMobileApp
    );
  }, []);

  return (
    <div
      className={classNames("LoadingScreen", {
        "is-fixed": fixed,
        "is-authorized-mobile-component": isAuthorizedMobileComponent,
        "is-trackstories-from-mobile": isTrackStoriesFromMobile,
      })}
    >
      <div className="LoadingScreen-container">
        <div className="iconWrapper">
          <Player
            autoplay={true}
            loop={true}
            src="/public/icons/lottie_loader_1_alt_alpha.json"
            style={{ width: "110px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
